import { useState } from "react";

const useExperimentModal = () => {
  const [selectedReleaseLabelGroupId, setSelectedReleaseLabelGroupId] =
    useState<number | null>(null);
  const [isExperimentModalOpen, setExperimentModalOpen] = useState(false);

  const handleDynamicReleaseLabelClick = (release_label_group_id: number) => {
    setSelectedReleaseLabelGroupId(release_label_group_id);
    setExperimentModalOpen(true);
  };

  return {
    selectedReleaseLabelGroupId,
    isExperimentModalOpen,
    setExperimentModalOpen,
    handleDynamicReleaseLabelClick,
  };
};

export default useExperimentModal;
